<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.customerTransaction')"
    resource="customer_transactions"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/customer_transactions.js';
import CustomerTransactionStagesInput from '@/components/customer-transactions/stages-input.vue';

@Component
export default class CustomerTransactions extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {
    stages: [100]
  }

  formatStages(value) {
    if (!Array.isArray(value) || !value.length) {
      return '/';
    }

    return value.map(stage => `${stage}%`).join(' / ');
  }

  validateStages(rule, value, callback) {
    if (!Array.isArray(value) || !value.length) {
      callback(new Error('请至少设置一个阶段比例'));
      return;
    }

    const invalidStage = value.find(stage => !Number.isInteger(stage) || stage < 1 || stage > 100);

    if (invalidStage !== undefined) {
      callback(new Error('每个阶段比例都必须是 1-100 的整数'));
      return;
    }

    if (value.reduce((sum, stage) => sum + stage, 0) !== 100) {
      callback(new Error('所有阶段比例之和必须等于 100%'));
      return;
    }

    callback();
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
      'name_cont',
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      'name',
      {
        key: 'stages',
        renderCell: (h, { props: { value } }) => h('span', this.formatStages(value))
      },
      type === 'show' && 'created_at',
      type === 'show' && 'updated_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
     * @param {Function} h - createElement
     * @param {Object} params
     * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
     * @param {String} params.resource - RESTful api resoure name
     * @param {Object} params.data - current form data
     * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
     */
  formColumns(h, { data, type }) {
    const array = [
      'name',
      {
        key: 'stages',
        renderCell: {
          required: true,
          component: (h, context) => h(CustomerTransactionStagesInput, context),
          hint: '可添加多个阶段，所有阶段比例之和必须保持为 100%',
          rules: [
            {
              validator: this.validateStages,
              trigger: 'change'
            }
          ]
        }
      },
    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'customer_transactions.edit', params: { id: row.id } }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'customer_transactions.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }
}

export const route = [
  {
    path: '/customer_transactions',
    name: 'customer_transactions.index',
    component: CustomerTransactions,
    props: {
      type: 'index',
    }
  },
  {
    path: '/customer_transactions/new',
    name: 'customer_transactions.new',
    component: CustomerTransactions,
    props: {
      type: 'new',
    }
  },
  {
    path: '/customer_transactions/:id',
    name: 'customer_transactions.show',
    component: CustomerTransactions,
    props: {
      type: 'show',
    }
  },
  {
    path: '/customer_transactions/:id/edit',
    name: 'customer_transactions.edit',
    component: CustomerTransactions,
    props: {
      type: 'edit'
    }
  }
]
</script>
